<template>
    <div class="md-layout">
        <!-- Novo Filtro -->
        <div class="md-layout-item md-size-100" data-app>
            <v-card class="mx-auto hidden-card">
                <maximize-and-minimize></maximize-and-minimize>
                <v-card-title>
                    <h4 class="title pt-1">Pesquisar</h4>
                </v-card-title>
                <div class="card-content">
                    <div>
                        <v-row>
                            <v-col>
                                <v-text-field
                                    label="Árvore de sortimento"
                                    name="node"
                                    id="node"
                                    value=""
                                    style="cursor: pointer"
                                    v-model="selectedHistoryFilterNodeName"
                                    @click="treeModalOpen(true)"
                                    readonly
                                />
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-autocomplete
                                    v-model="solicitationModel"
                                    :items="solicitations"
                                    item-text="name"
                                    item-value="id"
                                    :search-input.sync="searchSolicitations"
                                    cache-items
                                    class="mx-4"
                                    flat
                                    hide-no-data
                                    hide-details
                                    label="Pedido"
                                />
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-autocomplete
                                    v-model="productModel"
                                    :items="productsList"
                                    item-text="name"
                                    item-value="name"
                                    :search-input.sync="searchProducts"
                                    cache-items
                                    class="mx-4"
                                    flat
                                    hide-no-data
                                    hide-details
                                    label="Produto"
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="3">
                                <v-select
                                    name="solicitations-types"
                                    id="solicitations-types"
                                    v-model="selectedHistoryFilterFields.type"
                                    label="Tipo de Pedido"
                                    :items="solicitationsTypesData"
                                    item-text="description"
                                    item-value="id"
                                ></v-select>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-select
                                    v-model="selectedHistoryFilterFields.reason"
                                    :items="solicitationsReasonsData"
                                    item-text="description"
                                    item-value="id"
                                    label="Motivo"
                                ></v-select>
                            </v-col>
                            <v-col cols="12" md="2">
                                <v-select
                                    name="status"
                                    id="status"
                                    v-model="selectedHistoryFilterFields.status"
                                    label="Status"
                                    :items="statusList"
                                    item-text="text"
                                    item-value="status"
                                ></v-select>
                            </v-col>
                            <v-col cols="12" md="2">
                                <v-dialog
                                    v-model="dateStartMenu"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    min-width="auto"
                                    max-width="300px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="formattedStartDate"
                                            label="Data Início"
                                            prepend-icon="mdi-calendar"
                                            v-bind="attrs"
                                            v-on="on"
                                            @focusout.native="onFocusOutDate()"
                                            @keydown.native="
                                                onKeyDownDate($event)
                                            "
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="
                                            selectedHistoryFilterFields.start_date
                                        "
                                        @input="dateStartMenu = false"
                                        locale="pt-br"
                                        no-title
                                        :allowed-dates="allowedDates"
                                    ></v-date-picker>
                                </v-dialog>
                            </v-col>
                            <v-col cols="12" md="2">
                                <v-dialog
                                    v-model="dateEndMenu"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    min-width="auto"
                                    max-width="300px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="formattedEndDate"
                                            label="Data Fim"
                                            prepend-icon="mdi-calendar"
                                            v-bind="attrs"
                                            v-on="on"
                                            @focusout.native="onFocusOutDate()"
                                            @keydown.native="
                                                onKeyDownDate($event)
                                            "
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="
                                            selectedHistoryFilterFields.end_date
                                        "
                                        @input="dateEndMenu = false"
                                        locale="pt-br"
                                        no-title
                                        :allowed-dates="allowedDates"
                                    ></v-date-picker>
                                </v-dialog>
                            </v-col>
                        </v-row>

                        <div class="md-layout-item md-size-100 text-right mt-1">
                            <md-button
                                class="md-secondary md-sm ml-1"
                                @click="clearFilter()"
                            >
                                Limpar
                            </md-button>

                            <md-button
                                class="md-primary md-sm ml-1"
                                @click="applyFilter()"
                            >
                                Pesquisar
                            </md-button>
                        </div>
                    </div>
                </div>
            </v-card>
        </div>

        <generic-table
            :masterDetailShow="true"
            :data="tableData"
            :fieldNames="columnNames"
            :tooltipHeader="tooltip"
            :tooltipColumn="tooltipColumn"
            :columns="showColumns"
            :tableTitle="'Pedidos Filtrados'"
            :isLoading="filterLoading"
            :icon="'local_offer'"
            :masterDetailTitle="'Itens do Pedido'"
            @update:dataTable="wrapperData"
            @submitDetail="handleStatus"
            @editDetail="editOpen"
            @rejectDetail="handleStatus"
            @selectDetail="onSelectSolicitationItems"
        >
            <template slot="header">
                <div id="create-btn">
                    <Button
                        label="Criar Pedido"
                        type="secondary"
                        @click.native="createSolicitationModal = true"
                    />
                    <v-dialog v-model="createSolicitationModal" width="auto">
                        <v-card>
                            <v-card-text>
                                Escolha qual o tipo de pedido deseja criar:
                            </v-card-text>
                            <v-card-actions>
                                <Button
                                    v-for="(button,
                                    index) in solicitationModalButtons"
                                    :key="index"
                                    :label="button.label"
                                    type="secondary"
                                    @click.native="
                                        $router.push({
                                            name: 'Pedido',
                                            params: {
                                                solicitationType:
                                                    button.solicitationType
                                            }
                                        })
                                    "
                                />
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </div>
            </template>
            <template #pagination>
                <div class="">
                    <p class="card-category">
                        Mostrando
                        <select
                            id="numberItemPage"
                            v-model="pagination.perPage"
                        >
                            <option value="20">20</option>
                            <option value="40">40</option>
                            <option value="60">60</option>
                            <option value="80">80</option>
                            <option value="100">100</option>
                        </select>
                        itens de um total de {{ total }}.
                    </p>
                </div>

                <pagination
                    class="pagination-no-border pagination-success"
                    v-model="pagination.currentPage"
                    :per-page="Number(pagination.perPage)"
                    :total="total"
                >
                </pagination>
            </template>
        </generic-table>

        <!-- Modal to select tree node -->
        <modal v-if="treeModal" @close="treeModalOpen(false)" width="500px">
            <template slot="header">
                <h4 class="modal-title">Item da árvore de sortimento</h4>
                <md-button
                    class="md-simple md-just-icon md-round modal-default-button"
                    @click="treeModalOpen(false)"
                >
                    <md-icon>clear</md-icon>
                </md-button>
            </template>

            <template slot="body">
                <v-draggable-treeview
                    v-model="treeData"
                    :editable="false"
                    :openCallback="readTreeChild"
                    :clickCallback="selectTreeChild"
                ></v-draggable-treeview>
            </template>
            <template slot="footer"></template>
        </modal>

        <form @submit.prevent="editSubmit()">
            <modal v-if="editModal" @close="editCancel">
                <template slot="header">
                    <h4 class="modal-title">{{ editModalTitle }}</h4>
                    <md-button
                        class="md-simple md-just-icon md-round modal-default-button"
                        @click="editCancel()"
                    >
                        <md-icon>clear</md-icon>
                    </md-button>
                </template>

                <template slot="body">
                    <div>
                        <h6>
                            <strong
                                >Filial: {{ editModalSubTitle.branch }}</strong
                            >
                        </h6>
                        <h6>
                            <strong
                                >Produto:
                                {{ editModalSubTitle.product }}</strong
                            >
                        </h6>
                        <br />
                    </div>

                    <div class="md-layout" v-if="editExtraProduct">
                        <div
                            class="md-layout-item md-small-size-100 md-size-100"
                            v-for="field in editableFieldsExtraProduct"
                            :key="field"
                        >
                            <md-field v-if="field == 'branch_origin'">
                                <label>
                                    {{ columnNamesExtraProduct[field] }}
                                </label>
                                <md-select
                                    name="branchOrigin"
                                    id="branchOrigin"
                                    v-model="
                                        editModalModelExtraProduct[
                                            'branch_origin'
                                        ]
                                    "
                                    placeholder=""
                                >
                                    <md-option
                                        v-for="(dc, index) in dcsData"
                                        v-bind:key="`type-${index}`"
                                        :value="dc.id"
                                    >
                                        {{ dc.name }}
                                    </md-option>
                                </md-select>
                            </md-field>

                            <md-field v-else-if="field == 'status'">
                                <label>
                                    {{ columnNamesExtraProduct[field] }}
                                </label>
                                <md-select
                                    name="statusAssortmentParameter"
                                    id="statusAssortmentParameter"
                                    v-model="
                                        editModalModelExtraProduct['status']
                                    "
                                    placeholder=""
                                >
                                    <md-option
                                        v-for="(status, index) in [
                                            {
                                                value: 'R',
                                                name: 'Reprovado'
                                            },
                                            {
                                                value: 'A',
                                                name: 'Aprovado'
                                            }
                                        ]"
                                        v-bind:key="`type-${index}`"
                                        :value="status.value"
                                    >
                                        {{ status.name }}
                                    </md-option>
                                </md-select>
                            </md-field>

                            <md-field v-else-if="field == 'reason'">
                                <label>
                                    {{ columnNamesExtraProduct[field] }}
                                </label>
                                <md-select
                                    name="reason"
                                    id="reason"
                                    v-model="
                                        editModalModelExtraProduct['reason']
                                    "
                                    placeholder=""
                                >
                                    <md-option
                                        v-for="(reason,
                                        index) in solicitationsReasonsData"
                                        v-bind:key="`type-${index}`"
                                        :value="reason.id"
                                    >
                                        {{ reason.description }}
                                    </md-option>
                                </md-select>
                            </md-field>

                            <md-field v-else-if="field == 'response'">
                                <label>
                                    {{ columnNamesExtraProduct[field] }}
                                </label>
                                <md-textarea
                                    v-model="editModalModelExtraProduct[field]"
                                >
                                </md-textarea>
                            </md-field>

                            <md-field v-else>
                                <label>{{
                                    columnNamesExtraProduct[field]
                                }}</label>
                                <md-input
                                    v-model="editModalModelExtraProduct[field]"
                                    :type="fieldTypesExtraProduct[field]"
                                ></md-input>
                            </md-field>
                        </div>
                    </div>

                    <div class="md-layout" v-else-if="editAssortmentParameter">
                        <div
                            class="md-layout-item md-small-size-100 md-size-100"
                            v-for="field in editableFieldsAssortmentParameter"
                            :key="field"
                        >
                            <md-field v-if="field == 'status'">
                                <label>
                                    {{ columnNamesAssortmentParameter[field] }}
                                </label>
                                <md-select
                                    name="statusAssortmentParameter"
                                    id="statusAssortmentParameter"
                                    v-model="
                                        editModalModelAssortmentParameter[
                                            'status'
                                        ]
                                    "
                                    placeholder=""
                                >
                                    <md-option
                                        v-for="(status, index) in [
                                            {
                                                value: 'R',
                                                name: 'Reprovado'
                                            },
                                            {
                                                value: 'A',
                                                name: 'Aprovado'
                                            }
                                        ]"
                                        v-bind:key="`type-${index}`"
                                        :value="status.value"
                                    >
                                        {{ status.name }}
                                    </md-option>
                                </md-select>
                            </md-field>
                            <md-field v-else>
                                <label>{{
                                    columnNamesAssortmentParameter[field]
                                }}</label>
                                <md-input
                                    v-model="
                                        editModalModelAssortmentParameter[field]
                                    "
                                    :type="fieldTypesAssortmentParameter[field]"
                                ></md-input>
                            </md-field>
                        </div>
                    </div>

                    <div class="md-layout" v-else-if="editAssortmentProductAdd">
                        <div
                            class="md-layout-item md-small-size-100 md-size-100"
                            style="
                                overflow-x: visible;
                                margin-bottom: 10px;
                                margin-top: 10px;
                            "
                        >
                            <label class="artificial-label"> Código </label>
                            <vue-simple-suggest
                                v-model="commonProdModel"
                                :list="commonProdList"
                                :debounce="500"
                                placeholder="Código comum do produto"
                                display-attribute="name"
                                value-attribute="id"
                                @select="commonProdSelected"
                            >
                            </vue-simple-suggest>
                        </div>

                        <div
                            class="md-layout-item md-small-size-100 md-size-100"
                            style="overflow-x: visible; margin-bottom: 10px"
                        >
                            <label class="artificial-label"> Cor </label>
                            <vue-simple-suggest
                                v-model="colorModel"
                                :list="colorList"
                                :debounce="500"
                                placeholder="Cor"
                                display-attribute="name"
                                value-attribute="id"
                                :minLength="0"
                                @select="colorSelected"
                            >
                            </vue-simple-suggest>
                        </div>

                        <div
                            class="md-layout-item md-small-size-100 md-size-100"
                            style="overflow-x: visible; margin-bottom: 10px"
                        >
                            <label class="artificial-label"> Voltagem </label>
                            <vue-simple-suggest
                                v-model="voltageModel"
                                :list="voltageList"
                                :debounce="500"
                                placeholder="Voltagem"
                                display-attribute="name"
                                value-attribute="id"
                                :minLength="0"
                                @select="voltageSelected"
                            >
                            </vue-simple-suggest>
                        </div>

                        <md-field>
                            <label>
                                {{ columnNamesAssortmentProductAdd[status] }}
                            </label>
                            <md-select
                                name="statusAssortmentParameter"
                                id="statusAssortmentParameter"
                                v-model="
                                    editModalModelAssortmentProductAdd['status']
                                "
                                placeholder="Status"
                            >
                                <md-option
                                    v-for="(status, index) in [
                                        {
                                            value: 'R',
                                            name: 'Reprovado'
                                        },
                                        {
                                            value: 'A',
                                            name: 'Aprovado'
                                        }
                                    ]"
                                    v-bind:key="`type-${index}`"
                                    :value="status.value"
                                >
                                    {{ status.name }}
                                </md-option>
                            </md-select>
                        </md-field>

                        <md-field>
                            <label>{{
                                columnNamesAssortmentProductAdd['note']
                            }}</label>
                            <md-textarea
                                v-model="
                                    editModalModelAssortmentProductAdd['note']
                                "
                                :type="fieldTypesAssortmentProductAdd['note']"
                            ></md-textarea>
                        </md-field>
                    </div>
                </template>

                <template slot="footer">
                    <md-button class="md-simple" @click="editCancel()">
                        Cancelar
                    </md-button>
                    <md-button class="md-primary" type="submit">
                        Salvar
                    </md-button>
                </template>
            </modal>
        </form>
    </div>
</template>

<script>
import Vue from 'vue'
import { mapActions, mapState } from 'vuex'
import { GenericTable, Modal, VuetifyDraggableTreeview } from '@/components'
import Utils from '@/utils'
import Filter from '@/models/solicitationfilter.model'
import VueSimpleSuggest from 'vue-simple-suggest'
import { ProductService } from '@/services/product.service'

import { RestockingService } from '@/services/restocking.service'
import {
    Solicitation,
    Solicitation as Model
} from '@/models/solicitation.model'
import moment from 'moment'
import Node from '@/models/node.model'
import {
    status as Status,
    solicitationTypes as Types
} from '@/services/constants/index.js'
import MaximizeAndMinimize from '@/components/Maximize/MaximizeAndMinimize.vue'
import CustomSort from '@/mixins/CustomSort.vue'
import Button from '@/components/Button/Button.vue'
const permittedSolicitationTypes = [
    Types.TYPE_UPDATE_ASSORTMENT_PARAMETER_PK,
    Types.TYPE_REQUEST_EXTRA_PRODUCT_PK,
    Types.TYPE_REMOVE_PRODUCT_PK,
    Types.TYPE_ADD_PRODUCT_SYSTEM_PK,
    Types.TYPE_ADD_PRODUCT_MANAGER_PK
]

function buildSolicitations(data) {
    return data.map(solicitation => {
        return {
            id: solicitation.id,
            name: `${solicitation.id} - Filial ${solicitation.branch.external_id} - Qtd: ${solicitation.items.length}`
        }
    })
}

function setDisabledButtons(solicitationType) {
    return !permittedSolicitationTypes.includes(solicitationType)
}

function getBody(item) {
    return item.request_body_web && !_.isEmpty(item.request_body_web)
        ? item.request_body_web
        : item.request_body
}

function buildTableItem(item, solicitation) {
    const body = getBody(item)

    return {
        ...item,
        solicitation: {
            id: solicitation.id,
            request_user: solicitation.request_user,
            status: solicitation.status,
            branch_id: solicitation.branch.id
        },
        buttons: {
            submit: {
                disabled: item.status === Status.APPROVED
            },
            reject: {
                disabled: item.status === Status.REPROVED
            },
            edit: {
                disabled: setDisabledButtons(item.solicitation_type.id)
            }
        },
        rowContent: {
            productCurve: item.curve ? item.curve : '',
            is_new: item.is_new,
            is_guaranteed_stock: item.is_guaranteed_stock,
            is_favorite: item.is_favorite,
            productId: body?.product?.external_id,
            productName: body?.product?.name,
            note: item.note ?? '',
            response: item.response ?? '',
            productCurve: item.curve ? item.curve : '',
            action: item.solicitation_type.description
        },
        title: item.solicitation_type.description
    }
}

function buildTableColumns(model) {
    return Object.values(model).map(value => {
        return value
    })
}

function setRowStyle(status, columns) {
    let style =
        status == Status.REPROVED
            ? { color: 'var(--red-700)', background: 'var(--red-400)' }
            : status == Status.APPROVED
            ? { color: 'var(--green-700)', background: 'var(--green-400)' }
            : { color: 'var(--yellow-700)', background: 'var(--yellow-400)' }
    return { style, columns }
}

function setReprovedValue(status, value) {
    return status == Status.REPROVED ? '-' : value
}

function detailItemFactory(item) {
    const body = getBody(item)
    const { request_body, request_body_web } = item

    function extraProduct() {
        return {
            ...item,
            reason: (item.reason && item.reason.id) ?? null,
            columns: buildTableColumns(Model.extraProductFields),
            columnsToColor: setRowStyle(item.status, ['approved', 'requested']),
            rowContent: {
                ...item.rowContent,
                approved: setReprovedValue(
                    item.status,
                    request_body_web?.quantity
                ),
                requested: request_body ? request_body.quantity : '',
                reason: (item.reason && item.reason.description) ?? ''
            }
        }
    }

    function favoriteProduct() {
        return {
            ...item,
            columns: buildTableColumns(Model.favoriteProductsFields),
            columnsToColor: setRowStyle(item.status, ['action']),
            title: 'Alteração dos Favoritos',
            rowContent: {
                ...item.rowContent,
                productId: body.branchparameter.product
                    ? body.branchparameter.product.external_id
                    : '',
                productName: body.branchparameter.product
                    ? body.branchparameter.product.name
                    : ''
            }
        }
    }

    function changeProduct() {
        return {
            ...item,
            columns: buildTableColumns(Model.changeAssortmentFields),
            columnsToColor: setRowStyle(item.status, ['action']),
            title: 'Alteração do Sortimento'
        }
    }

    function assortmentParameter() {
        const requestedStoreCoverage =
            request_body?.stack_items + request_body?.showcase_items
        const approvedStoreCoverage =
            request_body_web?.stack_items + request_body_web?.showcase_items
        return {
            ...item,
            columns: buildTableColumns(Model.assortmentParameterFields),
            columnsToColor: setRowStyle(item.status, [
                'requestedStack',
                'approvedStack',
                'requestedShowcase',
                'approvedShowcase',
                'requestedCoverage',
                'approvedCoverage',
                'requestedStockMax',
                'approvedStockMax'
            ]),
            rowContent: {
                ...item.rowContent,
                productId: body?.branchparameter?.product.external_id,
                productName: body?.branchparameter?.product.name,
                requestedStack: request_body?.stack_items,
                approvedStack: setReprovedValue(
                    item.status,
                    request_body_web?.stack_items
                ),
                requestedShowcase: request_body?.showcase_items,
                approvedShowcase: setReprovedValue(
                    item.status,
                    request_body_web?.showcase_items
                ),
                requestedCoverage: request_body?.coverage,
                approvedCoverage: setReprovedValue(
                    item.status,
                    request_body_web?.coverage
                ),
                requestedStockMax: request_body?.stock_max,
                approvedStockMax: setReprovedValue(
                    item.status,
                    request_body_web?.stock_max
                ),
                currentCoverage: item.coverage + ' dias',
                coverageLimit: item.coverage_limit + ' dias',
                approvedStoreCoverage: setReprovedValue(
                    item.status,
                    (isNaN(approvedStoreCoverage) ? 0 : approvedStoreCoverage) +
                        ' dias'
                ),
                requestedStoreCoverage:
                    (isNaN(requestedStoreCoverage)
                        ? 0
                        : requestedStoreCoverage) + ' dias'
            }
        }
    }

    function amplitude() {
        return {
            ...item,
            columnsToColor: setRowStyle(item.status, ['approved', 'requested']),
            rowContent: {
                ...item.rowContent,
                tree: body?.node?.name,
                approved: setReprovedValue(
                    item.status,
                    request_body_web?.quantity
                ),
                requested: request_body ? request_body.quantity : ''
            },
            columns: buildTableColumns(Model.changeAmplitudeFields)
        }
    }

    return {
        extraProduct,
        assortmentParameter,
        changeProduct,
        favoriteProduct,
        amplitude
    }
}

function defineDetailContent(solicitation) {
    let changeProducts = []
    let favorites = []
    let extraProducts = []
    let amplitudes = []
    let assortment = []

    solicitation.items.forEach(item => {
        const solicitationType = item.solicitation_type.id
        item = buildTableItem(item, solicitation)
        const detailItem = detailItemFactory(item)
        switch (solicitationType) {
            case Types.TYPE_REQUEST_EXTRA_PRODUCT_PK:
                extraProducts.push(detailItem.extraProduct())
                break
            case Types.TYPE_UPDATE_ASSORTMENT_PARAMETER_PK:
                assortment.push(detailItem.assortmentParameter())
                break
            case Types.TYPE_REMOVE_PRODUCT_PK:
            case Types.TYPE_ADD_PRODUCT_SYSTEM_PK:
            case Types.TYPE_ADD_PRODUCT_MANAGER_PK:
                changeProducts.push(detailItem.changeProduct())
                break
            case Types.TYPE_FAVORITE_PRODUCT_PK:
            case Types.TYPE_REMOVE_FAVORITE_PRODUCT_PK:
                favorites.push(detailItem.favoriteProduct())
                break
            default:
                amplitudes.push(detailItem.amplitude())
        }
    })
    return {
        changeProducts,
        favorites,
        extraProducts,
        amplitudes,
        assortment
    }
}

export default {
    async created() {
        await this.readMe()
        const hasPermissionToAccess =
            this.me.permissions.includes('solicitations.view_solicitation') &&
            this.me.permissions.includes('solicitations.change_solicitation') &&
            this.me.permissions.includes(
                'solicitations.change_solicitationitem'
            )
        if (!hasPermissionToAccess) {
            this.$router.push('/')
            return
        }
        this.clearFilter()
        this.checkParams()
        await this.readSolicitationTypes()
        await this.readSolicitationReasons()
        await this.applyFilter()
        this.solicitations = buildSolicitations(this.queriedData.results)
    },
    components: {
        VueSimpleSuggest,
        'v-draggable-treeview': VuetifyDraggableTreeview,
        GenericTable,
        Pagination: () => import('@/components/Pagination'),
        Modal,
        MaximizeAndMinimize,
        Button
    },
    computed: {
        ...mapState({
            me: state => state['auth'].me,
            treeAncestors: state => state['nodes'].ancestors,
            solicitationsTypesData: state => state['solicitations'].types,
            solicitationsReasonsData: state => state['solicitations'].reasons,
            queriedData: state => state['solicitations'].page,
            filterLoading: state => state['solicitations'].filterLoading,
            dcsData: state => state['branches'].dcs,
            product: state => state['products'].current,
            branch: state => state['branches'].branch,
            branchParameter: state => state['branchparameter'].branchParameter,
            productsInfos: state => state['branchparameter'].listProduct,
            amplitude: state => state['restocking'].amplitude,
            stockState: state => state['movements'].stockState
        }),
        treeData() {
            return [{ name: 'Todos os itens', id: null }] //this.treePage.results
        },
        statusList() {
            return Object.keys(this.status).map(key => this.status[key])
        },
        to() {
            return this.queriedData.results.length > 0
                ? this.queriedData.results[this.queriedData.results.length - 1]
                      .id
                : 0
        },
        from() {
            return this.queriedData.results.length > 0
                ? this.queriedData.results[0].id
                : 0
        },
        total() {
            return this.queriedData.count
        },
        visibleColumns() {
            let columns = []
            Object.keys(this.showColumns).forEach(key => {
                if (this.showColumns[key]) columns.push(key)
            })

            return columns
        },

        tableData() {
            const data = this.queriedData.results.map(result => {
                return {
                    ...result,
                    branch_id: result.branch.id,
                    branch: result.branch.external_id,
                    request_user: result.request_user.name,
                    request_user_id: result.request_user.id,
                    response_user: result.response_user.name,
                    total_items: result.items.length,
                    detail: defineDetailContent(result)
                }
            })
            return this.orderByCustom(data)
        }
    },
    data() {
        return {
            mixinTypeSort: 'asc',
            loading: false,
            tooltip: { id: 'Identificador', total_items: 'Total de Itens' },
            tooltipColumn: {
                columnCount: 'solicitation_type',
                displayColumn: 'total_items'
            },
            selectedHistoryFilterNodeName: null,
            treeModal: false,
            columnsModal: false,
            new_product: '',
            selectedHistoryFilterFields: {
                product: null,
                type: null,
                reason: null,
                status: null,
                start_date: null,
                end_date: null
            },
            status: Filter.status, //Filter.status,
            commonProdModel: '',
            colorModel: '',
            colorId: '',
            voltageModel: '',
            productModel: '',
            formattedStartDate: '',
            formattedEndDate: '',
            dateStartMenu: false,
            dateEndMenu: false,
            productsList: [],
            solicitations: [],
            searchProducts: null,
            solicitationModel: null,
            searchSolicitations: null,
            showColumns: Model.visibleFields,
            currentSort: 'id',
            currentSortOrder: 'asc',
            columnNames: Model.fieldNames,
            editableFields: Object.keys(Model.editableFields),
            pagination: {
                perPage: parseInt(process.env.VUE_APP_DEFAULT_PAGE_SIZE),
                currentPage: 1,
                total: 0
            },
            selectedSolicitations: [],
            selectedSolicitationItems: [],
            actionVisible: null,
            allowedDates: date => {
                const now = moment.now()
                return date <= moment(now).format('YYYY-MM-DD')
            },
            name: '',
            start_date: '',
            end_date: '',

            editModalTitle: '',
            editModalSubTitle: {},
            editModal: false,

            editExtraProduct: false,
            editModalModelExtraProduct: {},
            showColumnsExtraProduct: Model.visibleFieldsExtraProduct,
            columnNamesExtraProduct: Model.fieldNamesExtraProduct,
            editableFieldsExtraProduct: Object.keys(
                Model.editableFieldsExtraProduct
            ),
            fieldTypesExtraProduct: Model.fieldTypesExtraProduct,
            editAssortmentProductAdd: false,
            editAssortmentParameter: false,
            editModalModelAssortmentProductAdd: {},
            editModalModelAssortmentParameter: {},
            fieldTypesAssortmentParameter: Model.fieldTypesAssortmentParameter,
            fieldTypesAssortmentProductAdd:
                Model.fieldTypesAssortmentProductAdd,
            columnNamesAssortmentParameter: Model.fieldNamesAssortmentParameter,
            columnNamesAssortmentProductAdd:
                Model.fieldNamesAssortmentProductAdd,
            editableFieldsAssortmentParameter: Object.keys(
                Model.editableFieldsAssortmentParameter
            ),
            editableFieldsAssortmentProductAdd: Object.keys(
                Model.editableFieldsAssortmentProductAdd
            ).filter(
                item =>
                    ['product_common_cod', 'product_color'].indexOf(item) == -1
            ),

            opened: [],
            allSelected: false,
            createSolicitationModal: false,
            solicitationModalButtons: [
                {
                    label: 'Reposição Dinâmica',
                    solicitationType: Types.TYPE_UPDATE_AMPLITUDE_PARAMETER_PK
                },
                {
                    label: 'Produto Extra',
                    solicitationType: Types.TYPE_REQUEST_EXTRA_PRODUCT_PK
                }
                // {
                //     label: 'Alteração dos Favoritos',
                //     solicitationType: Types.TYPE_FAVORITE_PRODUCT_PK
                // }
            ]
        }
    },
    mixins: [CustomSort],
    methods: {
        ...mapActions('auth', {
            readMe: 'me'
        }),
        ...mapActions('nodes', {
            readTreeNodes: 'read',
            readTreeAncestors: 'readAncestors'
        }),
        ...mapActions('movements', {
            readStockState: 'read'
        }),

        ...mapActions('solicitations', {
            readSolicitationTypes: 'readTypes',
            readSolicitationReasons: 'readReasons',
            _readSolicitations: 'readSolicitations',
            _filter: 'filter',
            updateSolicitation: 'updateSolicitation'
        }),

        ...mapActions('branches', {
            readDcs: 'readDcs',
            readBranchById: 'readById'
        }),

        ...mapActions('products', {
            readProductById: 'readById'
        }),

        ...mapActions('branchparameter', {
            readBranchParameterById: 'readById',
            _readDetailProduct: 'readDetailProduct'
        }),

        ...mapActions('restocking', {
            readAmplitudeById: 'readAmplitudeById'
        }),

        onKeyDownDate(e) {
            if (e.key === 'Tab' || e.key === 'Enter') {
                this.dateStartMenu = false
                this.dateEndMenu = false
            } else {
                if (
                    !e.key.match(/[0-9]/) &&
                    e.key !== 'ArrowLeft' &&
                    e.key !== 'ArrowRight' &&
                    e.key !== 'Backspace'
                ) {
                    e.preventDefault()
                }
            }
        },

        async wrapperData({ index, data }) {
            let products = []
            data.items.forEach(item => {
                const body = getBody(item)
                if (body?.product?.id) {
                    products.push(body.product.id)
                } else if (body?.branchparameter?.product?.id) {
                    products.push(body.branchparameter.product.id)
                }
            })

            if (products.length > 0) {
                await this._readDetailProduct({
                    branch: data.branch_id,
                    products: products.join(',')
                })

                this.queriedData.results[
                    index
                ].items = this.queriedData.results[index].items.map(e => {
                    const bodyKey =
                        e.request_body_web && !_.isEmpty(e.request_body_web)
                            ? 'request_body_web'
                            : 'request_body'

                    const productId = e[bodyKey].product
                        ? e[bodyKey].product.id
                        : e[bodyKey].branchparameter.product.id

                    const infos = this.productsInfos
                        .filter(item => {
                            return item.product.id === productId
                        })
                        .map(item => {
                            const {
                                curve,
                                is_favorite,
                                is_new,
                                is_guaranteed_stock
                            } = item
                            return {
                                curve,
                                is_favorite: is_favorite ?? false,
                                is_new: is_new ?? false,
                                is_guaranteed_stock:
                                    is_guaranteed_stock ?? false
                            }
                        })[0]

                    return {
                        ...e,
                        ...infos
                    }
                })
            }
        },

        onSelectSolicitationItems(items) {
            this.selectedSolicitationItems = items
        },

        isDateValid(date) {
            const isValid = moment(date, 'DD/MM/YYYY', true).isValid()
            if (!isValid) {
                this.notifyMessage('Data inválida', 'danger')
                return false
            }

            const isGreater = moment(date, 'DD/MM/YYYY') > moment()
            if (isGreater) {
                this.notifyMessage(
                    'A data não pode ser maior que a data de hoje!',
                    'danger'
                )
                return false
            }

            return true
        },

        onFocusOutDate() {
            // set timeout to "await" value update
            setTimeout(() => {
                const startDate = this.formattedStartDate
                const endDate = this.formattedEndDate

                if (startDate && !this.isDateValid(startDate)) {
                    this.formattedStartDate = ''
                }

                if (endDate && !this.isDateValid(endDate)) {
                    this.formattedEndDate = ''
                }
            }, 100)
        },

        async commonProdList() {
            let commonProd = await ProductService.readSolicitationProdCommonId({
                q: this.commonProdModel
            })
                .then(res => res.data)
                .then(json => json.results)
            commonProd = commonProd.map(item => {
                item.name = item.external_common_id
                return item
            })
            return commonProd
        },

        async voltageList() {
            if (this.commonProdModel && this.colorId) {
                let voltage = await ProductService.readSolicitationProdVoltage({
                    q: [this.commonProdModel, this.colorId]
                })
                    .then(res => res.data)
                    .then(json => json.results)
                voltage = voltage.map(item => {
                    item.name = item.voltage
                    return item
                })

                return voltage
            }
        },

        async colorList() {
            let colors = await ProductService.readSolicitationProdColors({
                q: this.commonProdModel
            })
                .then(res => res.data)
                .then(json => json.results)
            colors = colors.map(item => {
                item.name = item.color.external_id + ' - ' + item.color.name
                return item
            })
            return colors
        },

        async newProduct() {
            this.new_product = await ProductService.readSolicitationNewProd({
                q: [this.commonProdModel, this.colorId, this.voltageModel]
            })
            if (this.new_product.data.results.length > 0) {
                const formattedProduct =
                    this.new_product.data.results[0].external_id +
                    ' - ' +
                    this.new_product.data.results[0].name
                this.editModalSubTitle.product = formattedProduct
            } else {
                const undefinedProduct = 'Nenhum produto encontrado.'
                this.editModalSubTitle.product = undefinedProduct
            }
        },

        async readSolicitations(args) {
            if (!args) args = {}
            this.loading = true
            await Promise.all([this._readSolicitations(args)])
            this.loading = false
        },

        handleColumnsEdit() {
            this.columnsModal = true
        },

        columnsCancel() {
            this.columnsModal = false
        },

        treeModalOpen(state) {
            this.treeModal = state
        },

        commonProdSelected(selectedItem) {
            this.commonProdModel = selectedItem.external_common_id
            this.colorModel = ''
            this.colorId = ''
            this.voltageModel = ''
            this.editModalSubTitle.product = ''
        },

        colorSelected(selectedItem) {
            this.colorModel =
                selectedItem.color.external_id + ' - ' + selectedItem.color.name
            this.colorId = selectedItem.color.id
            this.voltageModel = ''
        },

        voltageSelected(selectedItem) {
            this.voltageModel = selectedItem.voltage
            if (this.commonProdModel && this.colorId && this.voltageList) {
                this.newProduct()
            }
        },

        async handleStatus(item, newStatus) {
            if (item) {
                newStatus =
                    newStatus === 'to submit' || newStatus === Status.APPROVED
                        ? Status.APPROVED
                        : Status.REPROVED

                const isApproved = newStatus === Status.APPROVED
                const objectName = item.solicitation ? 'Item' : 'Pedido'

                let errorMessage = isApproved
                    ? `Erro ao aprovar o ${objectName.toLowerCase()}.`
                    : `Erro ao reprovar o ${objectName.toLowerCase()}`

                let successMessage = isApproved
                    ? `${objectName} aprovado com sucesso!`
                    : `${objectName} reprovado com sucesso!`

                await this.update(item, newStatus, successMessage, errorMessage)
            }
        },

        async editSubmit() {
            let model = {}

            if (this.editExtraProduct) {
                model = this.editModalModelExtraProduct
            } else if (this.editAssortmentParameter) {
                model = this.editModalModelAssortmentParameter
            } else {
                if (
                    this.editModalSubTitle.product !==
                    'Nenhum produto encontrado.'
                ) {
                    model = {
                        ...this.editModalModelAssortmentProductAdd,
                        product: this.new_product
                            ? this.new_product.data.results[0].id
                            : this.editModalModelAssortmentProductAdd
                                  .new_product
                    }
                } else {
                    this.notifyMessage(
                        'Novo produto não encontrado, tente outros valores.',
                        'danger'
                    )
                    return
                }
            }

            model.status =
                model.status !== Status.APPROVED &&
                model.status !== Status.REPROVED
                    ? Status.PENDING
                    : model.status

            await this.update(
                model,
                model.status,
                'Item editado com sucesso!',
                'Erro ao editar o item.'
            )
            this.editExtraProduct = false
            this.editAssortmentParameter = false
            this.editAssortmentProductAdd = false
            this.editModal = false
            this.orderByCustom(this.tableData)
        },

        async setEditModalModelFactory(item) {
            const body = getBody(item)

            await this.readBranchById(item.solicitation.branch_id)

            const setEditModalModelExtraProduct = async () => {
                await this.readDcs({
                    relation: true,
                    product: body.product.id,
                    branch: body.branch
                })

                this.editModalModelExtraProduct = {
                    id: item.id,
                    quantity: body.quantity,
                    reason: item.reason,
                    branch: body.branch,
                    ...(body.branch_origin && {
                        branch_origin: body.branch_origin
                    }),
                    product: body.product,
                    status: item.status,
                    solicitation_type: item.solicitation_type,
                    solicitation: item.solicitation,
                    response: item.response,
                    note: item.note
                }
                await this.readProductById(body.product.id)
                await this.readBranchById(body.branch)

                this.product.name = body.product.name
                this.product.external_id = body.product.external_id
                this.editExtraProduct = true
                this.editAssortmentProductAdd = false
                this.editAssortmentParameter = false
                this.editModalSubTitle['product'] =
                    this.product.name + '-' + this.product.external_id
                this.editModalSubTitle['branch'] =
                    this.branch.name + '-' + this.branch.external_id
            }

            const setEditModalModelAssortmentParameter = async () => {
                this.editModalModelAssortmentParameter = {
                    id: item.id,
                    stack_items: body.stack_items,
                    showcase_items: body.showcase_items,
                    coverage: body.coverage,
                    stock_max: body.stock_max,
                    status: item.status,
                    solicitation_type: item.solicitation_type,
                    branchparameter: body.branchparameter,
                    solicitation: item.solicitation,
                    note: item.note
                }

                this.product.name = body.branchparameter.product.name
                this.product.external_id =
                    body.branchparameter.product.external_id
                this.editExtraProduct = false
                this.editAssortmentProductAdd = false
                this.editAssortmentParameter = true
            }

            const setEditModalModelAssortmentProductAdd = async () => {
                this.editModalModelAssortmentProductAdd = {
                    id: item.id,
                    new_product: body.product,
                    status: item.status,
                    solicitation_type: item.solicitation_type,
                    solicitation: item.solicitation,
                    note: item.note ?? ''
                }
                await this.readProductById(body.product.id)
                this.commonProdModel = this.product.external_common_id
                this.colorModel =
                    this.product.color?.id + ' - ' + this.product.color?.name
                this.voltageModel = this.product.voltage
                this.editModalSubTitle['product'] =
                    this.product.name + '-' + this.product.external_id
                this.editModalSubTitle['branch'] =
                    this.branch.name + '-' + this.branch.external_id
                this.editAssortmentParameter = false
                this.editExtraProduct = false
                this.editAssortmentProductAdd = true
            }

            switch (item.solicitation_type.id) {
                case Types.TYPE_REQUEST_EXTRA_PRODUCT_PK:
                    await setEditModalModelExtraProduct()
                    break
                case Types.TYPE_UPDATE_ASSORTMENT_PARAMETER_PK:
                    await setEditModalModelAssortmentParameter()
                    break
                case Types.TYPE_REMOVE_PRODUCT_PK:
                case Types.TYPE_ADD_PRODUCT_SYSTEM_PK:
                case Types.TYPE_ADD_PRODUCT_MANAGER_PK:
                    await setEditModalModelAssortmentProductAdd()
                    break
            }
        },

        //TODO: Verificar parametro action, não está em uso
        async editOpen(item, action) {
            try {
                if (item) {
                    const { id, status } = item

                    await this.setEditModalModelFactory(item)

                    if (status === Status.PENDING) {
                        await this.update(item, Status.IN_ANALYSIS)
                    }

                    this.editModalTitle = 'Editando #' + id
                    this.editModalSubTitle = {
                        ...this.editModalSubTitle,
                        product:
                            this.product.external_id +
                            ' - ' +
                            this.product.name,
                        branch:
                            this.branch.external_id + ' - ' + this.branch.name
                    }
                    this.editModal = true
                }
            } catch (error) {
                this.notifyMessage(
                    'Ocorreu um erro ao abrir o modal de edição do pedido.',
                    'danger'
                )
            }
        },

        async editCancel() {
            let model = {}

            if (this.editExtraProduct) {
                model = this.editModalModelExtraProduct
            } else if (this.editAssortmentParameter) {
                model = this.editModalModelAssortmentParameter
            } else {
                model = this.editModalModelAssortmentProductAdd
            }

            if (model.status === Status.IN_ANALYSIS) {
                await this.update(model, Status.PENDING)
            }
            this.editModal = false
            this.editExtraProduct = false
            this.editAssortmentParameter = false
        },

        async update(data, status, successMessage = null, errorMessage = null) {
            try {
                let solicitation = {}

                if (data.items) {
                    solicitation = {
                        ...data,
                        items: data.items.map(item => {
                            const {
                                solicitation,
                                solicitation_type,
                                request_body,
                                ...rest
                            } = item

                            return {
                                ...rest,
                                ...getBody(item),
                                solicitation: solicitation?.id ?? solicitation,
                                solicitation_type: solicitation_type.id,
                                status
                            }
                        })
                    }
                } else {
                    const { request_body, ...rest } = data

                    solicitation = {
                        ...rest,
                        ...getBody(data),
                        solicitation_type: data.solicitation_type.id
                    }
                }

                await this.updateSolicitation({ ...solicitation, status })
                if (successMessage) {
                    this.notifyMessage(successMessage, 'success')
                }
                await this.applyFilter()
            } catch (error) {
                this.notifyMessage(
                    errorMessage ??
                        `Oops, erro interno, tente novamente mais tarde. Erro:  ${error}`,
                    'danger'
                )
            }
        },

        async handleBulkStatus(newStatus) {
            let error = false
            let solicitationsToSend = this.selectedSolicitations.filter(
                solicitation => solicitation.status !== newStatus
            )
            let solicitationItemsToSend = this.selectedSolicitationItems.filter(
                item =>
                    item.status !== newStatus &&
                    solicitationsToSend.find(
                        solicitation => solicitation.id === item.solicitation.id
                    ) === undefined
            )
            await Promise.all([
                solicitationsToSend.map(async solicitation => {
                    error = await this.update(solicitation, newStatus)

                    if (error) {
                        let status =
                            newStatus === Status.APPROVED
                                ? 'aprovar'
                                : 'reprovar'
                        this.notifyMessage(
                            `Erro ao ${status} o pedido (${solicitation.id}).`,
                            'danger'
                        )

                        return
                    }
                }),

                solicitationItemsToSend.map(async item => {
                    error = await this.update(item, newStatus)

                    if (error) {
                        let status =
                            newStatus === Status.APPROVED
                                ? 'aprovar'
                                : 'reprovar'
                        this.notifyMessage(
                            `Erro ao ${status} o item (${item.id}).`,
                            'danger'
                        )

                        return
                    }
                })
            ])

            if (!error) {
                let status =
                    newStatus === Status.APPROVED
                        ? 'aprovado(s)'
                        : 'reprovado(s)'
                this.notifyMessage(`Envio(s) ${status} com sucesso!`, 'success')
            }

            this.allSelected = false
        },

        async nameTreeNode(idNode) {
            await this.readTreeAncestors({ id: idNode })
            if (idNode && this.treeAncestors.length > 0) {
                this.selectedHistoryFilterNodeName = ''
                this.treeAncestors.forEach((ancestor, index) => {
                    if (index > 0) this.selectedHistoryFilterNodeName += ' > '
                    this.selectedHistoryFilterNodeName += ancestor.name
                })
                this.selectedHistoryFilterNode = this.treeAncestors[
                    this.treeAncestors.length - 1
                ]
            } else {
                this.selectedHistoryFilterNode = new Node()
                this.selectedHistoryFilterNodeName = 'Todos os itens'
            }
        },

        readTreeChild(item) {
            return this.readTreeNodes({ item })
        },

        async selectTreeChild(item) {
            this.nameTreeNode(item.id)
            this.treeModal = false
        },

        async applyFilter() {
            this.start_date = !this.selectedHistoryFilterFields.start_date
                ? null
                : Utils.formatByMoment(
                      this.selectedHistoryFilterFields.start_date,
                      '-'
                  )

            this.end_date = !this.selectedHistoryFilterFields.end_date
                ? null
                : Utils.formatByMoment(
                      this.selectedHistoryFilterFields.end_date,
                      '-'
                  )

            this.name = this.productModel.split(' - ')[1] || this.productModel

            let args = {
                id: this.solicitationModel,
                status: this.selectedHistoryFilterFields.status,
                reason: this.selectedHistoryFilterFields.reason,
                type: this.selectedHistoryFilterFields.type,
                name: this.name,
                parent: this.selectedHistoryFilterNode.id,
                start_date: this.start_date,
                end_date: this.end_date,
                page: 1,
                limit: this.pagination.perPage
            }
            this.pagination.currentPage = 1
            await this.readSolicitations(args)

            this.queriedData.results.forEach(async result => {
                result.items = await Promise.all(
                    result.items.map(async item => {
                        if (
                            item.solicitation_type &&
                            item.solicitation_type.id ===
                                Types.TYPE_UPDATE_ASSORTMENT_PARAMETER_PK
                        ) {
                            const body = getBody(item)
                            if (body && !_.isEmpty(body)) {
                                const showcase_items = body?.showcase_items ?? 0
                                const stack_items = body?.stack_items ?? 0
                                await this.readStockState({
                                    products: [
                                        body?.branchparameter?.product?.id
                                    ],
                                    quantity: showcase_items + stack_items,
                                    branch: result.branch.id
                                })
                            }
                            item.coverage = this.stockState
                                ? this.stockState[0]?.coverage
                                : 0
                            item.coverage_limit = this.stockState
                                ? this.stockState[0]?.coverage_limit
                                : 0
                        }
                        return item
                    })
                )
            })
        },

        filterProducts() {
            clearTimeout(this._timerId)

            this._timerId = setTimeout(async () => {
                let products = await ProductService.read({
                    q: this.searchProducts
                })
                    .then(res => res.data)
                    .then(json => json.results)
                this.productsList = products.map(item => {
                    item.name = item.external_id + ' - ' + item.name
                    return item
                })
            }, 2000)
        },

        filter() {
            clearTimeout(this._timerId)

            this._timerId = setTimeout(async () => {
                const hasSolicitation = this.solicitations.some(
                    item =>
                        item.id == this.searchSolicitations ||
                        item.name == this.searchSolicitations
                )

                if (!hasSolicitation) {
                    let filteredSolicitations = await this._filter({
                        q: this.searchSolicitations
                    })
                    filteredSolicitations = buildSolicitations(
                        filteredSolicitations.data.results
                    )
                    filteredSolicitations.forEach(solicitation => {
                        if (
                            !this.solicitations.some(
                                item => item.id === solicitation.id
                            )
                        ) {
                            this.solicitations.push(solicitation)
                        }
                    })
                }
            }, 2000)
        },

        notifyMessage(message, type) {
            this.$notify({
                message,
                icon: 'add_alert',
                horizontalAlign: 'right',
                verticalAlign: 'bottom',
                type
            })
        },

        sortByColumn(column) {
            if (column === this.currentSort) {
                this.currentSortOrder =
                    this.currentSortOrder === 'asc' ? 'desc' : 'asc'
            }
            this.currentSort = column
        },

        clearFilter() {
            this.selectedHistoryFilterNode = new Node()
            this.selectedHistoryFilterNodeName = 'Todos os itens'
            this.productModel = ''
            this.solicitationModel = null
            this.selectedHistoryFilterFields.product = null
            this.selectedHistoryFilterFields.type = ''
            this.selectedHistoryFilterFields.reason = ''
            this.selectedHistoryFilterFields.status = ''
            this.selectedHistoryFilterFields.start_date = null
            this.selectedHistoryFilterFields.end_date = null
            this.formattedStartDate = ''
            this.formattedEndDate = ''
        },

        checkParams() {
            const startDate = this.$route.params.startDate
            const endDate = this.$route.params.endDate
            const status = this.$route.params.status

            if (startDate) {
                this.selectedHistoryFilterFields.start_date = new Date(
                    startDate
                )
            }

            if (endDate) {
                this.selectedHistoryFilterFields.end_date = new Date(endDate)
            }

            if (status) {
                this.selectedHistoryFilterFields.status = status
            }
        }
    },
    watch: {
        pagination: {
            handler: function(val) {
                let args = {
                    status: this.selectedHistoryFilterFields.status,
                    reason: this.selectedHistoryFilterFields.reason,
                    type: this.selectedHistoryFilterFields.type,
                    name: this.name,
                    parent: this.selectedHistoryFilterNode.id,
                    start_date: this.start_date,
                    end_date: this.end_date,
                    page: val.currentPage,
                    limit: +val.perPage
                }
                this.readSolicitations(args)
            },
            deep: true
        },

        allSelected: {
            handler: function() {
                this.selectedSolicitations = []
                this.selectedSolicitationItems = []

                if (this.allSelected) {
                    this.tableData.forEach(solicitation => {
                        this.selectedSolicitations.push(solicitation)
                        solicitation.items.forEach(item => {
                            this.selectedSolicitationItems.push(item)
                        })
                    })
                }
            }
        },

        searchSolicitations: {
            handler: function(val) {
                val && val !== this.solicitationModel && this.filter()
            }
        },

        searchProducts: {
            handler: function(val) {
                val && val !== this.productModel && this.filterProducts()
            }
        },

        'selectedHistoryFilterFields.start_date': {
            handler: function(val) {
                if (val) {
                    this.formattedStartDate = Utils.formatByMoment(val)
                }
            }
        },

        'selectedHistoryFilterFields.end_date': {
            handler: function(val) {
                if (val) {
                    this.formattedEndDate = Utils.formatByMoment(val)
                }
            }
        }
    },
    mounted() {
        this.$watch(
            () => {
                return this.formattedStartDate
            },
            (val, old) => {
                if (val) {
                    const newVal = val.replaceAll('/', '')

                    if (newVal.length <= 2) {
                        this.formattedStartDate = `${newVal}`
                    } else if (newVal.length === 3) {
                        this.formattedStartDate = `${newVal.substring(
                            0,
                            2
                        )}/${newVal.substring(2, 4)}`
                    } else if (newVal.length === 4) {
                        this.formattedStartDate = `${newVal.substring(
                            0,
                            2
                        )}/${newVal.substring(2, 4)}`
                    } else if (newVal.length >= 5) {
                        this.formattedStartDate = `${newVal.substring(
                            0,
                            2
                        )}/${newVal.substring(2, 4)}/${newVal.substring(4, 8)}`
                    }
                }
            }
        )

        this.$watch(
            () => {
                return this.formattedEndDate
            },
            (val, old) => {
                if (val) {
                    const newVal = val.replaceAll('/', '')

                    if (newVal.length <= 2) {
                        this.formattedEndDate = `${newVal}`
                    } else if (newVal.length === 3) {
                        this.formattedEndDate = `${newVal.substring(
                            0,
                            2
                        )}/${newVal.substring(2, 4)}`
                    } else if (newVal.length === 4) {
                        this.formattedEndDate = `${newVal.substring(
                            0,
                            2
                        )}/${newVal.substring(2, 4)}`
                    } else if (newVal.length >= 5) {
                        this.formattedEndDate = `${newVal.substring(
                            0,
                            2
                        )}/${newVal.substring(2, 4)}/${newVal.substring(4, 8)}`
                    }
                }
            }
        )
    }
}
</script>

<style lang="css" scoped>
.md-table-toolbar {
    padding-left: 2rem !important;
    padding-right: 2rem !important;
}

.modal-wrapper .md-checkbox {
    display: flex !important;
}

.vue-simple-suggest.designed {
    width: 100%;
}

.md-table-row {
    text-align: center;
    cursor: pointer;
}

.fix-toolbar {
    position: fixed;
    right: 0;
    bottom: 0;
    /* height: 60px; */
}

.fix-toolbar div {
    display: flex;
    justify-content: center;
}

#td-actions {
    height: 65px;
}

.card-content {
    margin: auto;
    padding: 28px 65px;
}

#create-btn {
    margin: 10px 0px;
}

#numberItemPage {
    border: 1px solid #ccc;
}

.v-dialog > .v-card {
    padding: 10px;
}

.v-card__actions {
    display: block;
}

.v-card__actions > button {
    width: 100%;
    margin: 10px 0;
}
</style>
